(function(){
  'use strict';
  var d=document,h=d.documentElement,w=window;
  var mm=function(q){return w.matchMedia?w.matchMedia(q):{matches:false};};
  var reduce=h.classList.contains('kz-rm')||mm('(prefers-reduced-motion: reduce)').matches;
  var motion=!reduce&&h.classList.contains('kz-js');
  var fine=mm('(hover:hover) and (pointer:fine)').matches;
  var mob=mm('(max-width:749px)');
  var vh=w.innerHeight,headH=68;
  var clamp=function(v,a,b){return v<a?a:v>b?b:v;};
  var ease=function(t){return 1-Math.pow(1-t,3);};
  w.kzMotion=true;
  try{if(localStorage.getItem('kz-theme')==='light'&&!h.hasAttribute('data-theme'))h.setAttribute('data-theme','light');}catch(e){}
  var isLight=function(){return h.getAttribute('data-theme')==='light';};

  /* one frame loop for everything */
  var jobs=[],layouts=[],running=false,lastKick=0;
  function loop(t){var busy=false;for(var i=0;i<jobs.length;i++){if(jobs[i](t))busy=true;}if(busy||performance.now()-lastKick<800){requestAnimationFrame(loop);}else{running=false;}}
  function kick(){lastKick=performance.now();if(!running){running=true;requestAnimationFrame(loop);}}
  function measure(){vh=w.innerHeight;headH=parseFloat(getComputedStyle(h).getPropertyValue('--head'))||68;}
  measure();
  w.addEventListener('scroll',kick,{passive:true});
  var rz;w.addEventListener('resize',function(){clearTimeout(rz);rz=setTimeout(function(){measure();layouts.forEach(function(f){f();});kick();},120);});
  function pinP(el){var r=el.getBoundingClientRect();return clamp((headH-r.top)/Math.max(r.height-(vh-headH),1),0,1);}

  /* intro: the kanji traces itself once per visit */
  var intro=d.querySelector('[data-kz-intro]'),introPending=false,afterIntro=[];
  if(intro&&motion&&getComputedStyle(intro).display!=='none'){
    introPending=true;
    var draw=intro.querySelector('.kz-draw'),done=false,started=false;
    var finish=function(){if(done)return;done=true;intro.classList.add('is-out');introPending=false;d.dispatchEvent(new Event('kz:intro'));afterIntro.forEach(function(f){f();});setTimeout(function(){if(intro.parentNode)intro.parentNode.removeChild(intro);},1500);};
    var start=function(){if(started)return;started=true;draw.classList.add('is-go');setTimeout(finish,2900);};
    if(d.fonts&&d.fonts.load){d.fonts.load('400 84px "Zen Old Mincho"','絆').then(start,start);}
    setTimeout(start,1300);
    intro.addEventListener('click',finish);
    d.addEventListener('keydown',finish,{once:true});
    w.addEventListener('wheel',finish,{once:true,passive:true});
    w.addEventListener('touchmove',finish,{once:true,passive:true});
  }

  /* the kanji traces itself on the story page too */
  d.querySelectorAll('.kz-draw').forEach(function(sv){
    if(intro&&intro.contains(sv))return;
    var go=function(){sv.classList.add('is-go');};
    if(!motion){go();return;}
    if(d.fonts&&d.fonts.load){d.fonts.load('400 84px "Zen Old Mincho"','絆').then(go,go);}
    setTimeout(go,1300);
  });

  /* titles come out of the smoke, letter by letter */
  function split(el){
    var label=el.textContent.replace(/\s+/g,' ').trim(),i=0;
    (function walk(node){
      Array.prototype.slice.call(node.childNodes).forEach(function(n){
        if(n.nodeType===3){
          var frag=d.createDocumentFragment();
          n.nodeValue.split(/(\s+)/).forEach(function(p){
            if(!p)return;
            if(/^\s+$/.test(p)){frag.appendChild(d.createTextNode(' '));return;}
            var wd=d.createElement('span');wd.className='kz-wd';wd.setAttribute('aria-hidden','true');
            Array.from(p).forEach(function(c){var s=d.createElement('span');s.className='kz-ch';s.style.setProperty('--i',i++);s.textContent=c;wd.appendChild(s);});
            frag.appendChild(wd);
          });
          node.replaceChild(frag,n);
        }else if(n.nodeType===1&&n.tagName!=='BR'){walk(n);}
      });
    })(el);
    el.setAttribute('aria-label',label);
    el.classList.add('is-split');
  }
  var proxy=new Map();
  var io=('IntersectionObserver' in w)?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){show(proxy.get(e.target)||e.target);io.unobserve(e.target);}});},{rootMargin:'0px 0px -4% 0px',threshold:0.01}):null;
  function watch(el){var t=el;if(el.getAttribute('data-kz-r')==='curtain'&&el.parentNode){t=el.parentNode;proxy.set(t,el);}io.observe(t);}
  function show(el){el.classList.add('is-in');setTimeout(function(){el.classList.add('is-done');},2800);}
  d.querySelectorAll('[data-kz-stagger]').forEach(function(c){var k=0;c.querySelectorAll('[data-kz-r]').forEach(function(el){if(!el.hasAttribute('data-kz-d'))el.style.setProperty('--d',(k++*110)+'ms');});});
  d.querySelectorAll('[data-kz-r]').forEach(function(el){
    if(el.hasAttribute('data-kz-d'))el.style.setProperty('--d',el.getAttribute('data-kz-d')+'ms');
    if(!motion||!io){el.classList.add('is-in');return;}
    if(el.getAttribute('data-kz-r')==='chars')split(el);
    if(el.hasAttribute('data-kz-after-intro')){if(introPending){afterIntro.push(function(){show(el);});}else{requestAnimationFrame(function(){show(el);});}return;}
    watch(el);
  });

  /* mobile sticky buy bar */
  d.querySelectorAll('[data-kz-sticky]').forEach(function(bar){
    var target=d.querySelector(bar.getAttribute('data-kz-sticky'));
    if(!target||!('IntersectionObserver' in w)){bar.classList.add('is-on');return;}
    new IntersectionObserver(function(e){var r=e[0];bar.classList.toggle('is-on',!r.isIntersecting&&r.boundingClientRect.top<0);}).observe(target);
  });

  /* product gallery: only the views of the chosen colour */
  d.querySelectorAll('[data-kz-gallery]').forEach(function(g){
    var track=g.querySelector('.kz-track');
    if(!track)return;
    var allS=[].slice.call(g.querySelectorAll('.kz-slide')),allT=[].slice.call(g.querySelectorAll('.kz-thumbs button')),slides=allS,thumbs=allT;
    function set(i){slides.forEach(function(s,j){s.classList.toggle('is-on',i===j);});thumbs.forEach(function(b,j){b.classList.toggle('is-on',i===j);b.setAttribute('aria-current',i===j?'true':'false');});}
    g._kzPick=function(c){
      var ok=function(el){var k=el.getAttribute('data-kz-mc');return !c||!k||k===c;};
      slides=allS.filter(ok);thumbs=allT.filter(ok);
      allS.forEach(function(s){if(!ok(s))s.classList.remove('is-on');});
      allT.forEach(function(b){if(!ok(b)){b.classList.remove('is-on');b.setAttribute('aria-current','false');}});
      track.scrollLeft=0;set(0);
    };
    allT.forEach(function(b){b.addEventListener('click',function(){var i=thumbs.indexOf(b);if(i<0)return;if(mob.matches){track.scrollTo({left:track.clientWidth*i,behavior:reduce?'auto':'smooth'});}set(i);});});
    track.addEventListener('scroll',function(){if(!mob.matches)return;set(Math.round(track.scrollLeft/Math.max(track.clientWidth,1)));},{passive:true});
  });

  /* the light that reveals the hidden kanji */
  d.querySelectorAll('[data-kz-lamp]').forEach(function(el){
    var auto=el.hasAttribute('data-kz-drift');
    var st={x:auto?.2:.5,y:auto?.72:.5,tx:auto?.2:.5,ty:auto?.72:.5,last:0,vis:true};
    el._kz=st;
    function set(){el.style.setProperty('--x',(st.x*el.clientWidth).toFixed(1)+'px');el.style.setProperty('--y',(st.y*el.clientHeight).toFixed(1)+'px');}
    function mv(ev){var r=el.getBoundingClientRect();st.tx=(ev.clientX-r.left)/r.width;st.ty=(ev.clientY-r.top)/r.height;st.last=performance.now();kick();}
    el.addEventListener('pointermove',mv);el.addEventListener('pointerdown',mv);
    if(!motion){st.x=st.tx=auto&&!mob.matches?.73:.5;st.y=st.ty=auto?(mob.matches?.29:.5):.5;set();layouts.push(set);return;}
    var t0=null,wait=auto&&introPending;
    if(wait)afterIntro.push(function(){wait=false;t0=null;kick();});
    if('IntersectionObserver' in w)new IntersectionObserver(function(e){st.vis=e[0].isIntersecting;if(st.vis)kick();}).observe(el);
    jobs.push(function(t){
      if(!st.vis)return false;
      if(auto&&!wait){
        if(t0===null)t0=t;
        if(performance.now()-st.last>2500){
          var s=(t-t0)/1000;
          var cx=mob.matches?.5:.73,cy=mob.matches?.29:.5,ax=mob.matches?.22:.13,ay=mob.matches?.12:.17;
          if(s<2.8){var e=ease(s/2.8);st.tx=.2+(cx-.2)*e;st.ty=.72+(cy-.72)*e;}
          else{var u=s-2.8;st.tx=cx+Math.sin(u*.31)*ax+Math.sin(u*.73)*ax*.25;st.ty=cy+Math.cos(u*.23)*ay;}
        }
      }
      st.x+=(st.tx-st.x)*.1;st.y+=(st.ty-st.y)*.1;set();
      return auto||Math.abs(st.tx-st.x)+Math.abs(st.ty-st.y)>.001;
    });
    set();kick();
  });

  /* living smoke in the threshold */
  d.querySelectorAll('[data-kz-smoke]').forEach(function(cv){
    var ctx=cv.getContext('2d');if(!ctx)return;
    var host=cv.closest('[data-kz-lamp]'),W,H,img,px,last=0,t0=performance.now(),vis=true;
    var P=new Uint8Array(512),seed=1234567,i,j,tmp;
    for(i=0;i<256;i++)P[i]=i;
    for(i=255;i>0;i--){seed=(seed*16807)%2147483647;j=seed%(i+1);tmp=P[i];P[i]=P[j];P[j]=tmp;}
    for(i=0;i<256;i++)P[i+256]=P[i];
    function n2(x,y){var xi=Math.floor(x),yi=Math.floor(y),xf=x-xi,yf=y-yi;xi&=255;yi&=255;var a=P[P[xi]+yi],b=P[P[xi+1]+yi],c=P[P[xi]+yi+1],e=P[P[xi+1]+yi+1];var u=xf*xf*(3-2*xf),v=yf*yf*(3-2*yf);return (a+(b-a)*u+(c-a)*v+(a-b-c+e)*u*v)/255;}
    function fbm(x,y){var s=0,a=.5;for(var o=0;o<4;o++){s+=a*n2(x,y);x=x*2.03+17.1;y=y*2.03+3.7;a*=.5;}return s;}
    function size(){var r=cv.getBoundingClientRect(),k=mob.matches?12:10;W=Math.max(32,Math.round(r.width/k));H=Math.max(24,Math.round(r.height/k));cv.width=W;cv.height=H;img=ctx.createImageData(W,H);px=img.data;}
    function paint(t){
      var time=(t-t0)/1000,st=host&&host._kz,lx=st?st.x:.5,ly=st?st.y:.46,asp=W/H,k=0;
      for(var y=0;y<H;y++){var ny=y/H*2.2;for(var x=0;x<W;x++){var nx=x/W*2.2*asp;
        var q=fbm(nx+time*.035,ny-time*.025);
        var v=fbm(nx+q*1.7+time*.05,ny+q*1.3-time*.018);
        var a=(v-.4)/.38;a=a<0?0:a>1?1:a;a=a*a*(3-2*a);
        var dx=(x/W-lx)*asp,dy=y/H-ly,c=(Math.sqrt(dx*dx+dy*dy)-.05)/.34;c=c<0?0:c>1?1:c;
        a*=.25+.75*c;
        px[k]=150;px[k+1]=156;px[k+2]=168;px[k+3]=a*92|0;k+=4;}}
      ctx.putImageData(img,0,0);
    }
    size();layouts.push(size);
    if(!motion){paint(t0+6000);return;}
    if('IntersectionObserver' in w)new IntersectionObserver(function(e){vis=e[0].isIntersecting;if(vis)kick();}).observe(cv);
    jobs.push(function(t){if(!vis||d.hidden)return false;if(t-last>33){last=t;paint(t);}return true;});
    kick();
  });

  /* far and near: the pinned zoom */
  d.querySelectorAll('[data-kz-zoom]').forEach(function(el){
    var fr=el.querySelector('.kz-zoom__frame'),cur=-1;
    function lay(){if(fr)el.style.setProperty('--fh',fr.offsetHeight+'px');}
    lay();layouts.push(lay);
    if(!motion)return;
    jobs.push(function(){var e=ease(clamp((pinP(el)-.03)/.75,0,1));if(Math.abs(e-cur)>.0004){cur=e;el.style.setProperty('--e',e.toFixed(4));}return false;});
  });

  /* manifesto, line by line */
  d.querySelectorAll('[data-kz-mani]').forEach(function(el){
    var lines=el.querySelectorAll('.kz-ml'),n=lines.length,cur=-2;
    if(!motion||!n)return;
    jobs.push(function(){var p=pinP(el),a=p>=.97?n:Math.min(n-1,Math.floor(p*n*1.05));if(a!==cur){cur=a;lines.forEach(function(l,k){l.classList.toggle('is-on',a>=n||k===a);l.classList.toggle('is-past',a<n&&k<a);});}return false;});
  });

  /* the two parts of the kanji come apart */
  d.querySelectorAll('[data-kz-parts]').forEach(function(el){
    if(!motion)return;
    jobs.push(function(){var r=el.getBoundingClientRect();el.style.setProperty('--q',ease(clamp((vh*.9-r.top)/(vh*.6),0,1)).toFixed(3));return false;});
  });

  /* a light turns on */
  d.querySelectorAll('[data-kz-light]').forEach(function(el){
    if(!motion)return;
    jobs.push(function(){var r=el.getBoundingClientRect();el.style.setProperty('--l',ease(clamp((vh-r.top)/(vh*.8),0,1)).toFixed(3));return false;});
  });

  if(fine&&motion){
    /* product image follows the hand */
    d.querySelectorAll('[data-kz-tilt]').forEach(function(el){
      el.addEventListener('pointermove',function(ev){var r=el.getBoundingClientRect();el.style.setProperty('--tx',((ev.clientX-r.left)/r.width*2-1).toFixed(3));el.style.setProperty('--ty',((ev.clientY-r.top)/r.height*2-1).toFixed(3));});
      el.addEventListener('pointerleave',function(){el.style.setProperty('--tx',0);el.style.setProperty('--ty',0);});
    });
    /* the worn photo spreads from where the cursor enters */
    d.querySelectorAll('.kz-card__m').forEach(function(m){
      function at(ev){var r=m.getBoundingClientRect();m.style.setProperty('--mx',((ev.clientX-r.left)/r.width*100).toFixed(1)+'%');m.style.setProperty('--my',((ev.clientY-r.top)/r.height*100).toFixed(1)+'%');}
      var card=m.closest('.kz-card')||m;
      card.addEventListener('pointerenter',at);card.addEventListener('pointerleave',at);
    });
    /* a soft light carried by the cursor */
    var g=d.createElement('div');g.className='kz-glow';g.setAttribute('aria-hidden','true');d.body.appendChild(g);
    var gx=-999,gy=-999,tgx=gx,tgy=gy;
    d.addEventListener('pointermove',function(ev){tgx=ev.clientX;tgy=ev.clientY;if(gx<-900){gx=tgx;gy=tgy;}var t=ev.target;g.classList.toggle('is-on',!(t&&t.closest&&t.closest('.kz-seuil,.kz-intro,.kz-lens')));kick();},{passive:true});
    h.addEventListener('mouseleave',function(){g.classList.remove('is-on');});
    jobs.push(function(){gx+=(tgx-gx)*.14;gy+=(tgy-gy)*.14;g.style.transform='translate3d('+gx.toFixed(1)+'px,'+gy.toFixed(1)+'px,0)';return Math.abs(tgx-gx)+Math.abs(tgy-gy)>.5;});
  }

  /* the thread that runs down the page and closes into the circle */
  var main=d.body.hasAttribute('data-kz-thread')?d.getElementById('kz-main'):null;
  if(main){
    var NS='http://www.w3.org/2000/svg',svg=d.createElementNS(NS,'svg');
    svg.setAttribute('class','kz-thread');svg.setAttribute('aria-hidden','true');
    svg.innerHTML="<defs><radialGradient id='kz-tg'><stop offset='0' stop-color='currentColor' stop-opacity='.55'/><stop offset='1' stop-color='currentColor' stop-opacity='0'/></radialGradient></defs><path/><circle class='kz-tip-g' r='16' fill='url(#kz-tg)'/><circle class='kz-tip' r='1.8'/>";
    main.insertBefore(svg,main.firstChild);
    var path=svg.querySelector('path'),tipG=svg.querySelector('.kz-tip-g'),tip=svg.querySelector('.kz-tip');
    var L=0,ringStart=0,ringY=Infinity,samples=[],curLen=0,ringOn=false,ringT0=0;
    var f1=function(v){return v.toFixed(1);};
    var build=function(){
      var hr=main.getBoundingClientRect(),W=hr.width,top=hr.top,small=mob.matches,pts=[];
      d.querySelectorAll('[data-kz-knot]').forEach(function(el){
        var r=el.getBoundingClientRect();
        el.getAttribute('data-kz-knot').split(';').forEach(function(s){var a=s.trim().split(/\s+/);pts.push({x:small?12:parseFloat(a[0])*W,y:r.top-top+parseFloat(a[1])*r.height});});
      });
      pts.sort(function(a,b){return a.y-b.y;});
      var rel=d.querySelector('[data-kz-ring]'),ring=null;
      if(rel){var rr=rel.getBoundingClientRect();ring={cx:rr.left-hr.left+rr.width/2,cy:rr.top-top+rr.height/2,rx:rr.width/2+(small?18:30),ry:rr.height/2+(small?16:22)};}
      if(pts.length<2){svg.style.display='none';return;}
      svg.style.display='';
      var Q=[pts[0]];
      for(var i=1;i<pts.length;i++){var a=pts[i-1],b=pts[i];Q.push({x:(a.x+b.x)/2+(small?6:W*.045)*(i%2?1:-1),y:(a.y+b.y)/2});Q.push(b);}
      var s='M'+f1(Q[0].x)+' '+f1(Q[0].y);
      for(i=0;i<Q.length-1;i++){var p0=Q[i-1]||Q[i],p1=Q[i],p2=Q[i+1],p3=Q[i+2]||p2;s+=' C'+f1(p1.x+(p2.x-p0.x)/6)+' '+f1(p1.y+(p2.y-p0.y)/6)+' '+f1(p2.x-(p3.x-p1.x)/6)+' '+f1(p2.y-(p3.y-p1.y)/6)+' '+f1(p2.x)+' '+f1(p2.y);}
      if(ring){
        var e=Q[Q.length-1],tx=ring.cx,ty=ring.cy-ring.ry;
        s+=' C'+f1(e.x)+' '+f1(e.y+(ty-e.y)*.7)+' '+f1(tx-ring.rx*.7)+' '+f1(ty)+' '+f1(tx)+' '+f1(ty);
        path.setAttribute('d',s);ringStart=path.getTotalLength();ringY=ty;
        s+=' A'+f1(ring.rx)+' '+f1(ring.ry)+' 0 0 1 '+f1(tx)+' '+f1(ring.cy+ring.ry)+' A'+f1(ring.rx)+' '+f1(ring.ry)+' 0 0 1 '+f1(tx-.5)+' '+f1(ty);
      }
      path.setAttribute('d',s);L=path.getTotalLength();if(!ring){ringStart=L;ringY=Infinity;}
      svg.setAttribute('width',W);svg.setAttribute('height',hr.height);svg.setAttribute('viewBox','0 0 '+W+' '+hr.height);svg.style.height=hr.height+'px';
      samples=[];for(var k=0;k<=240;k++){var l=ringStart*k/240;samples.push([l,path.getPointAtLength(l).y]);}
      path.style.strokeDasharray=L+' '+L;
      if(!motion){path.style.strokeDashoffset=0;tip.style.display=tipG.style.display='none';}
      kick();
    };
    var lenAt=function(y){if(!samples.length||y<=samples[0][1])return 0;for(var k=1;k<samples.length;k++){if(samples[k][1]>=y){var a=samples[k-1],b=samples[k];return a[0]+(b[0]-a[0])*clamp((y-a[1])/Math.max(b[1]-a[1],.001),0,1);}}return ringStart;};
    build();layouts.push(build);
    w.addEventListener('load',build);
    if(d.fonts&&d.fonts.ready)d.fonts.ready.then(build);
    if('ResizeObserver' in w){var rt;new ResizeObserver(function(){clearTimeout(rt);rt=setTimeout(build,150);}).observe(main);}
    if(motion)jobs.push(function(t){
      if(!L)return false;
      var y=vh*.62-main.getBoundingClientRect().top,target=lenAt(y);
      if(ringStart<L&&y>=ringY-12){if(!ringOn){ringOn=true;ringT0=t;}target=ringStart+(L-ringStart)*ease(clamp((t-ringT0)/1700,0,1));}
      else if(ringOn&&y<ringY-140){ringOn=false;}
      curLen+=(target-curLen)*.12;
      path.style.strokeDashoffset=f1(L-curLen);
      var pt=path.getPointAtLength(curLen),o=curLen>2&&curLen<L-2?1:0;
      tip.setAttribute('cx',f1(pt.x));tip.setAttribute('cy',f1(pt.y));tipG.setAttribute('cx',f1(pt.x));tipG.setAttribute('cy',f1(pt.y));
      tip.style.opacity=tipG.style.opacity=o;
      return Math.abs(target-curLen)>.4||(ringOn&&t-ringT0<1800);
    });
  }

  /* colour follows the mode: white pieces on the dark site, black pieces on the light site */
  var pdp=d.querySelector('[data-kz-pdp]'),pdpSync=null;
  if(pdp){
    var radios=[].slice.call(pdp.querySelectorAll('input[name=id][data-kz-c]')),auto=pdp.getAttribute('data-kz-sel')==='auto',gal=pdp.querySelector('[data-kz-gallery]');
    var choose=function(c,user){
      var r=null;radios.forEach(function(x){if(x.getAttribute('data-kz-c')===c)r=x;});
      if(!r)return;
      r.checked=true;
      if(!auto)pdp.setAttribute('data-kz-sel',c);
      var av=r.getAttribute('data-kz-av')==='true',sku=r.getAttribute('data-kz-sku')||'';
      d.querySelectorAll('[data-kz-v=name]').forEach(function(el){el.textContent=r.getAttribute('data-kz-name');});
      d.querySelectorAll('[data-kz-v=price]').forEach(function(el){el.textContent=r.getAttribute('data-kz-price');});
      d.querySelectorAll('[data-kz-v=sku]').forEach(function(el){el.textContent=sku;if(el.parentNode)el.parentNode.hidden=!sku;});
      d.querySelectorAll('[data-kz-v=buy]').forEach(function(b){b.disabled=!av;b.querySelectorAll('[data-kz-when]').forEach(function(sp){sp.hidden=(sp.getAttribute('data-kz-when')==='on')!==av;});});
      if(gal&&gal._kzPick)gal._kzPick(c);
      if(user){try{history.replaceState(history.state,'',r.getAttribute('data-kz-url'));}catch(e){}}
    };
    radios.forEach(function(r){r.addEventListener('change',function(){if(!r.checked)return;auto=false;choose(r.getAttribute('data-kz-c'),true);});});
    if(radios.length){
      pdpSync=function(){if(auto)choose(isLight()?'n':'b',false);};
      if(auto)pdpSync();else choose(pdp.getAttribute('data-kz-sel'),false);
    }
  }
  var syncMode=function(){
    var k=isLight()?'l':'d';
    d.querySelectorAll('[data-kz-href-d]').forEach(function(a){var u=a.getAttribute('data-kz-href-'+k);if(u)a.setAttribute('href',u);});
    d.querySelectorAll('[data-kz-quick]').forEach(function(f){
      var id=f.getAttribute('data-kz-id-'+k),inp=f.querySelector('input[name=id]'),b=f.querySelector('button');
      if(id&&inp)inp.value=id;
      f.hidden=f.getAttribute('data-kz-av-'+k)!=='true';
      if(b)b.setAttribute('aria-label',f.getAttribute('data-kz-label-'+k)||'');
    });
    if(pdpSync)pdpSync();
  };
  syncMode();

  /* light or dark */
  var modes=d.querySelectorAll('[data-kz-mode]');
  var label=function(){var l=isLight();modes.forEach(function(b){b.setAttribute('aria-label',l?'Passer en mode sombre':'Passer en mode clair');b.setAttribute('aria-pressed',l?'true':'false');});var m=d.querySelector('meta[name=theme-color]');if(m)m.setAttribute('content',l?'#E7E7E2':'#0B0C0F');};
  var apply=function(l){if(l)h.setAttribute('data-theme','light');else h.removeAttribute('data-theme');try{localStorage.setItem('kz-theme',l?'light':'dark');}catch(e){}label();syncMode();kick();};
  label();
  w.addEventListener('pageshow',function(ev){if(!ev.persisted)return;var l=false;try{l=localStorage.getItem('kz-theme')==='light';}catch(e){}if(l!==isLight()){if(l)h.setAttribute('data-theme','light');else h.removeAttribute('data-theme');label();syncMode();}});
  modes.forEach(function(b){b.addEventListener('click',function(){
    var next=!isLight();
    if(!motion||!d.startViewTransition){apply(next);return;}
    var r=b.getBoundingClientRect();h.style.setProperty('--cx',(r.left+r.width/2).toFixed(0)+'px');h.style.setProperty('--cy',(r.top+r.height/2).toFixed(0)+'px');
    h.classList.add('kz-swap');
    var t=d.startViewTransition(function(){apply(next);});
    var end=function(){h.classList.remove('kz-swap');};
    t.finished.then(end,end);
  });});

  /* cookie preferences */
  d.querySelectorAll('[data-kz-cookies]').forEach(function(a){
    a.addEventListener('click',function(ev){if(w.privacyBanner&&typeof w.privacyBanner.showPreferences==='function'){ev.preventDefault();w.privacyBanner.showPreferences();}});
  });

  kick();
})();
